// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","SpacingMD":"15px","button":"Gb6e926"};